import React, { useContext } from 'react';
import { Nav } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import showcaseIcon from '../assets/showcase.svg';
import dashboardIcon from '../assets/dashboard.svg';
import productsIcon from '../assets/products.svg';
import purchasesIcon from '../assets/purchases.svg';
import settingsIcon from '../assets/settings.svg';
import superadminIcon from '../assets/superadmin.svg';
import logoutIcon from '../assets/logout.svg';
import databaseIcon from '../assets/database.svg';
import servicesIcon from '../assets/services.svg';
import './Sidebar.css';

// With React you have to prefix the environment variable with REACT_APP_
const STORE_API_URL = process.env.REACT_APP_API_URL;

const Sidebar = ({ isMobile = false, closeNavbar = null, isCollapsed, setIsCollapsed }) => {
  const { isAuthenticated, setIsAuthenticated, setToken, role } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const response = await fetch(`${STORE_API_URL}/auth/logout`, {
        method: 'GET',
        credentials: 'include',
      });
      if (response.ok) {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
        setToken(null);
        navigate('/');
      } else {
        console.error('Logout failed.');
      }
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const toggleSidebar = () => setIsCollapsed(!isCollapsed);

  if (!isAuthenticated) {
    return null;
  }

  const navItems = (
    <>
      <Nav.Link href="/dashboard" className={isMobile ? 'd-lg-none' : ''} title={isCollapsed ? 'Dashboard' : ''}>
        <img src={dashboardIcon} alt="Dashboard" style={{ height: '30px', marginRight: isCollapsed ? '0' : '8px' }} />
        {!isCollapsed && <span>Dashboard</span>}
      </Nav.Link>
      <Nav.Link href="/showcase" className={isMobile ? 'd-lg-none' : ''} title={isCollapsed ? 'Showcase' : ''}>
        <img src={showcaseIcon} alt="Showcase" style={{ height: '30px', marginRight: isCollapsed ? '0' : '8px' }} />
        {!isCollapsed && <span>Showcase</span>}
      </Nav.Link>
      <Nav.Link href="/products" className={isMobile ? 'd-lg-none' : ''} title={isCollapsed ? 'Products' : ''}>
        <img src={productsIcon} alt="Products" style={{ height: '30px', marginRight: isCollapsed ? '0' : '8px' }} />
        {!isCollapsed && <span>Products</span>}
      </Nav.Link>
      <Nav.Link href="/services" className={isMobile ? 'd-lg-none' : ''} title={isCollapsed ? 'Services' : ''}>
        <img src={servicesIcon} alt="Services" style={{ height: '30px', marginRight: isCollapsed ? '0' : '8px' }} />
        {!isCollapsed && <span>Services</span>}
      </Nav.Link>
      {['basic_seller', 'pro_seller', 'super'].includes(role) && (
        <>
          <Nav.Link href="/purchases" className={isMobile ? 'd-lg-none' : ''} title={isCollapsed ? 'Purchases' : ''}>
            <img src={purchasesIcon} alt="Purchases" style={{ height: '30px', marginRight: isCollapsed ? '0' : '8px' }} />
            {!isCollapsed && <span>Purchases</span>}
          </Nav.Link>
        </>
      )}
      {role === 'super' && (
        <>
          <Nav.Link href="/superadmin" className={isMobile ? 'd-lg-none' : ''} title={isCollapsed ? 'Superadmin' : ''}>
            <img src={superadminIcon} alt="Superadmin" style={{ height: '30px', marginRight: isCollapsed ? '0' : '8px' }} />
            {!isCollapsed && <span>Superadmin</span>}
          </Nav.Link>
          <Nav.Link href="/superadmin/crts" className={isMobile ? 'd-lg-none' : ''} title={isCollapsed ? 'CRT Database' : ''}>
            <img src={databaseIcon} alt="Database" style={{ height: '30px', marginRight: isCollapsed ? '0' : '8px' }} />
            {!isCollapsed && <span>CRT Database</span>}
          </Nav.Link>
        </>
      )}
      <Nav.Link href="/settings" className={isMobile ? 'd-lg-none' : ''} title={isCollapsed ? 'Settings' : ''}>
        <img src={settingsIcon} alt="Settings" style={{ height: '30px', marginRight: isCollapsed ? '0' : '8px' }} />
        {!isCollapsed && <span>Settings</span>}
      </Nav.Link>
      <hr className="my-2" style={{ borderColor: 'var(--bs-border-color)' }} />
      <Nav.Link onClick={handleLogout} className={isMobile ? 'd-lg-none' : ''} title={isCollapsed ? 'Logout' : ''}>
        <img src={logoutIcon} alt="Logout" style={{ height: '30px', marginRight: isCollapsed ? '0' : '8px' }} />
        {!isCollapsed && <span>Logout</span>}
      </Nav.Link>
    </>
  );

  if (isMobile) {
    return (
      <>
        <hr className="d-lg-none my-2" style={{ borderColor: 'var(--bs-border-color)' }} />
        {navItems}
      </>
    );
  }

  return (
    <div className={`sidebar ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
      <div className="sidebar-toggle" onClick={toggleSidebar}>
        <svg 
          width="20" 
          height="20" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          className={`toggle-arrow ${isCollapsed ? 'rotated' : ''}`}
        >
          <polyline points="15,18 9,12 15,6"></polyline>
        </svg>
      </div>
      <Nav className="flex-column">
        {navItems}
      </Nav>
    </div>
  );
};

export default Sidebar; 